import React from 'react';
import TextInput from '../../form/TextInput';
import Select from '../../form/Select';
import createForm from "./Form";

class figureForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row">
                    <div className="col-md-4">
                        <img src={this.props.values.url} className="img-responsive"/>
                    </div>
                    <div className="col-md-8">
                        <div className="row form-row">
                            <div className="col-md-4">
                                <TextInput name={this.props.componentConfig.idfield} value={this.props.values[this.props.componentConfig.idfield]} label="Kód"
                                           role="idfield" {...this.props.getFieldProps(this.props.componentConfig.idfield)}/>
                            </div>
                            <div className="col-md-4">
                                <TextInput name="path" value={this.props.values.path} label="Útvonal"
                                       saveChanges={this.props.path} {...this.props.getFieldProps("path")} disabled={true}/>
                            </div>
                            <div className="col-md-4">
                                <TextInput name="name" value={this.props.values.name} label="Név"
                                           saveChanges={this.props.setFieldValue} {...this.props.getFieldProps("name")} disabled={true}/>
                            </div>
                        </div>
                        <div className="row form-row">
                            <div className="col-md-6">
                                <TextInput name="caption" value={this.props.values.caption} label="Kép aláírás"
                                           saveChanges={this.props.setFieldValue} {...this.props.getFieldProps("caption")}/>
                            </div>
                            <div className="col-md-6">
                                <Select
                                    optionname="image_role"
                                    name="role"
                                    value={this.props.values.role}
                                    isClearable={true}
                                    label="Csoport"
                                    storeType="local"
                                    objectValue={false}
                                    saveChanges={this.props.setFieldValue}
                                    {...this.props.getFieldProps("role")}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(figureForm);
